module.exports = __webpack_public_path__ + "img/528.03987043.png";